import {
  CLIENT_ID,
  ACCESS_TOKEN,
  OUTLET_LIST,
  RESET_STATE,
  OUTLET_ID,
  QUICK_ACTION,
  ME_DETAILS,
  PAGE_INFO,
  MENU_LIST,
  APP_INTEGRATIONS
} from "../action";

const initialState = {
  accessToken: null,
  clientId: null,
  storedOutlets: [],
  selectedOutletId: "",
  storePageInfo: []
};

const storeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ACCESS_TOKEN: {
      return {
        ...state,
        accessToken: action.payload,
      };
    }
    case CLIENT_ID: {
      return {
        ...state,
        clientId: action.payload,
      };
    }
    case OUTLET_LIST: {
      return {
        ...state,
        storedOutlets: action.payload
      }
    }
    case RESET_STATE: {
      return initialState;
    }
    case OUTLET_ID: {
      return {
        ...state,
        storeSelectedOutlet: action.payload
      }
    }
    case QUICK_ACTION: {
      return {
        ...state,
        storedAction: action.payload
      }
    }
    case PAGE_INFO: {
      const updatedList: any = [...state.storePageInfo];

      const index = updatedList.findIndex((p: any) => p.type === action.payload.type);

      if (index !== -1) {
        // Update the current module (merge)
        updatedList[index] = {
          ...updatedList[index],
          ...action.payload
        };
      } else {
        // Add new module entry
        updatedList.push(action.payload);
      }

      // 🔥 Reset page for all other modules
      const finalList = updatedList.map((info: any) => {
        if (info.type !== action.payload.type) {
          return {
            ...info,
            page: 1   // reset page to 1 for other modules
          };
        }
        return info;
      });

      return {
        ...state,
        storePageInfo: finalList
      };
    }


    case ME_DETAILS: {
      return {
        ...state,
        meDetails: action.payload
      }
    }
    case MENU_LIST: {
      return {
        ...state,
        menuList: action.payload
      }
    }
    case APP_INTEGRATIONS: {
      return {
        ...state,
        appIntegrations: action.payload
      }
    }
    default:
      return state;


  }


};

export default storeReducer;
